import { useMemo } from 'react';

import { farmWorkOrdersService } from '../../../../services/farmWorkOrdersService';
import { createApiSlice } from '../../utils/createApiSlice';

const updateFarmWorkOrderSlice = createApiSlice({
  reducerPath: ['newGrowths', 'farmWorkOrders', 'updateFarmWorkOrder'],
  apiFunction: farmWorkOrdersService.updateFarmWorkOrderV2,
  apiArgumentsFn: ({ growerId, seasonId, farmId, workOrderId, data }) => [
    growerId,
    seasonId,
    farmId,
    workOrderId,
    data
  ]
});

const { actions, useApiSelectors } = updateFarmWorkOrderSlice;

export const updateFarmWorkOrderActions = actions;

export const useUpdateFarmWorkOrderSelectors = () => {
  const { inProgress, errorMessage, success, updatedAt } = useApiSelectors();

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      updatedAt
    }),
    [errorMessage, inProgress, success, updatedAt]
  );
};

export default updateFarmWorkOrderSlice;
